export default (cartSell, cards) => {
  return Object.keys(cartSell).length !== 0
    ? cartSell.cardIds.reduce((memo, value) => {
        return Number(memo) + Number(cards[value].cashValue);
      }, 0)
    : 0;
};
